/**
 * Loading Spinner Component
 */

import { Box, CircularProgress } from '@mui/material';
import React from 'react';

export const LoadingSpinner: React.FC = () => {
  return (
    <Box
      data-testid="loading-spinner"
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh',
      }}
    >
      <CircularProgress />
    </Box>
  );
};
